import * as React from 'react';
import { Button } from 'primereact/button';
import { Alert } from 'reactstrap';
import { useAuth0 } from '../../../auth/react-auth0-wrapper'
import moment from 'moment';

export default function CanCheck({
    trigger,
    triggerNextStep,
    deviceId,
    canCodeId,
    step
}) {

    const { gisApi } = useAuth0();
    const completed = step.value && step.value.completed;
    const error = step.value && step.value.error;

    async function getCan() {
        //test linea CAN
        const command = "lvcangetinfo";
        await gisApi.sendComand(
            deviceId,
            command,
            command,
            false
        );                
    }

    async function setCan() {
        //invio codice linea CAN al dispositivo
        const command = "lvcansetprog " + canCodeId;
        await gisApi.sendComand(
            deviceId,
            command,
            command,
            false
        );                
    }

    return (
        <Alert color={error ? 'danger' : completed ? 'success' : 'info'} title="Test rilevazione della linea CAN">

            {completed && (
                <div className="text-green mb-4">
                    {
                        `Test controllo presenza della linea CAN effettuato`
                    }
                </div>
            )}

            {error && <div>{error}</div>}

            {!completed && !error && (
                <div>
                    <div className="mb-2">{`Il motore del veicolo è acceso?`}</div>
                    <Button
                        label={`SI`}
                        icon="pi pi-check"
                        style={{ marginRight: "5px" }}
                        onClick={async () => {
                            const setResult = await setCan();
                            const testResult = await getCan();
                            triggerNextStep({
                                trigger: trigger,
                                value: { completed: true, timestamp: moment().toJSON() }
                            });
                        }}
                        className="p-button-success p-button-rounded"
                    />

                    <Button
                        label={`NO`}
                        icon="pi pi-times"
                        style={{ marginRight: "5px" }}
                        onClick={() => {
                            triggerNextStep({
                                trigger: step.id,
                                value: {
                                    error: `Accensione del motore veicolo rifiutata dall'operatore`, timestamp: moment().toJSON()
                                }
                            });
                        }}
                        className="p-button-danger p-button-rounded"
                    />
                </div>
            )}

        </Alert>
    );

}
